import { RootState } from '@/store/main';

export const selectStylepacks = (state: RootState) => state.stylepacks.stylepacks;
export const selectLoadingStylepacks = (state: RootState) => state.stylepacks.loadingStylepacks;
export const selectErrorLoadingStylepacks = (state: RootState) => state.stylepacks.errorLoadingStylepacks;
export const selectStylepackContent = (state: RootState) => state.stylepacks.stylepackContent;
export const selectStylepackAudio = (state: RootState) => state.stylepacks.stylepackAudio;
